import React from 'react';
import logoLarge from '../../../assets/images/logo-type.svg';
import logoSmall from '../../../assets/icons/logo-small.svg';
import './Brand.scss';

export type BrandVariant = 'large' | 'small';

export interface BrandProps {
  className?: string;
  variant?: BrandVariant;
  height?: number;
  isMain?: boolean;
}

const Brand: React.FC<BrandProps> = ({
  className = '',
  variant = 'small',
  height = 40,
}) => {
  const isLarge = variant === 'large';

  return (
    <div
      className={`brand-block brand-block--${variant} ${className}`.trim()}
    >
      {isLarge ? (
        <img src={logoLarge} alt='Logotype' />
      ) : (
        <img src={logoSmall} alt='' height={height} style={{ height }} />
      )}
    </div>
  );
};

export default Brand;
